import { DRUPAL_NODE_DISPLAY, type DrupalImage, type DrupalNodePage } from '@commons/types/drupal';

import IntelligenceNodeCard from './Card';
import IntelligenceNodeFeatured from './Featured';
import IntelligenceNodeFeaturedTile from './FeaturedTile';
import IntelligenceNodeLabel from './Label';
import IntelligenceNodeTile from './Tile';

/**
 * Type definition of a Intelligence node properties.
 */

export type IntelligenceNodeProps = DrupalNodePage & {
  date: string;
  image?: DrupalImage;
  summary?: string;
};

/**
 * Intelligence node component.
 *
 * Renders a component based on the display type.
 */

export const IntelligenceNode = (props: IntelligenceNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <IntelligenceNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <IntelligenceNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Tile:
      return <IntelligenceNodeTile {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <IntelligenceNodeFeaturedTile {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <IntelligenceNodeFeatured {...props} />;
  }
};

export default IntelligenceNode;
